import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SupportFormComponent} from './iframe/support-form.component';
import {DcpSupportFormService} from './dcp-support-form.service';
import {IframeModule} from '../iframe/iframe.module';
import {ConfigModule} from '@spartacus/core';
import {SupportFormPageComponent} from './stand-alone/support-form-page.component';
import {SafePipeModule} from '../../pipes/safeResourceUrl/safeResourceUrl.module';

@NgModule({
  declarations: [
    SupportFormComponent,
    SupportFormPageComponent
  ],
  imports: [
    CommonModule,
    IframeModule,
    ConfigModule.withConfig({
      cmsComponents: {
        SupportFormPageComponent: {
          component: SupportFormPageComponent,
        }
      }
    }),
    SafePipeModule
  ],
  providers: [
    DcpSupportFormService
  ]
})
export class DcpSupportFormModule {
}
